import { z } from 'zod'
import { LINK_SOURCES } from '../enums'
import { id, optionalEmail, optionalText, requiredText } from './common'

export const contactInputSchema = z.object({
  name: requiredText(200, 'שם איש הקשר הוא שדה חובה'),
  email: optionalEmail(),
  phone: optionalText(40),
  /**
   * The projects this contact is attached to, with the role in each. A full replacement
   * when present; left out, the existing links are not touched.
   */
  projects: z
    .array(z.object({ projectId: id(), role: optionalText(120) }))
    .max(200)
    .optional(),
})

export type ContactInput = z.infer<typeof contactInputSchema>

export const contactQuerySchema = z.object({
  search: optionalText(200),
})

/** Attaching an existing contact to a project or a case, with the role it plays there. */
export const contactLinkSchema = z.object({
  contactId: id(),
  role: optionalText(120),
})

export type ContactLinkInput = z.infer<typeof contactLinkSchema>

export type ContactDto = {
  id: string
  name: string
  email: string | null
  phone: string | null
  createdAt: string
  updatedAt: string
  linkCount?: number
}

/** The contact card, with the projects it is attached to. */
export type ContactDetail = ContactDto & {
  projects: { projectId: string; projectName: string; role: string | null }[]
}

/** A contact as shown on a case: either inherited from the project or linked directly. */
export type LinkedContactDto = ContactDto & {
  role: string | null
  source: (typeof LINK_SOURCES)[number]
  removable: boolean
}
